import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import { omit } from "lodash";
import "./period.scss";
import { isSameYear, isSameMonth } from "date-fns";

const Period = ({ fromDate, endDate, format, prefix, suffix, reduce = false }) => {
	const prefixNode = prefix ? <span className="period__prefix">{prefix}</span> : false;
	const sameYear = fromDate && endDate && isSameYear(fromDate, endDate);
	const sameMonth = fromDate && endDate && isSameMonth(fromDate, endDate);

	let fromDateFormat = format;
	if (reduce && sameYear) {
		fromDateFormat = omit(fromDateFormat, ["year"]);
	}
	if (reduce && sameMonth) {
		fromDateFormat = omit(fromDateFormat, ["month"]);
	}

	const fromDateNode = fromDate ? (
		<div className="period__start">
			{prefixNode}
			<span className="period__date">
				<FormattedDate timeZone="UTC" value={new Date(fromDate)} {...fromDateFormat} />
			</span>
		</div>
	) : (
		false
	);

	const endDateNode = endDate ? (
		<div className="period__end">
			<span className="period__suffix">{suffix}</span>

			<span className="period__date">
				<FormattedDate timeZone="UTC" value={new Date(endDate)} {...format} />
			</span>
		</div>
	) : (
		false
	);

	return (
		<div className="period">
			{fromDateNode}
			{endDateNode}
		</div>
	);
};

Period.propTypes = {
	fromDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	endDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	format: PropTypes.object,
	suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	reduce: PropTypes.bool,
};

export default Period;
